import React from 'react'
import { View, TouchableOpacity, StyleSheet } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Icon, IconName, Text } from '@components'

export interface MenuItem {
  id: string
  title: string
  icon: IconName
  screen: string
  showDivider?: boolean
}

interface MenuItemProps {
  item: MenuItem
  onPress: (screen: string) => void
}

export const MenuItem: React.FC<MenuItemProps> = ({ item, onPress }) => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <>
      <TouchableOpacity
        style={styles.container}
        onPress={() => onPress(item.screen)}
        activeOpacity={0.7}
      >
        <View style={styles.iconContainer}>
          <Icon name={item.icon} size={20} color="#666" />
        </View>
        <Text type="bodySmall" style={styles.title}>{item.title}</Text>
      </TouchableOpacity>
      {item.showDivider && <View style={styles.divider} />}
    </>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 16,
      paddingHorizontal: 20,
      borderBottomWidth: 0, 
      backgroundColor: 'white',
    },
    iconContainer: {
      width: 28,
      alignItems: 'flex-start',
      marginRight: 5,
    },
    title: {
      fontSize: 15, 
      color: '#2c2c2c',
      fontWeight: '400',
      flex: 1,
    },
    divider: {
      height: 1,
      backgroundColor: theme.colors.grey,
      marginLeft: 10, 
      marginRight: 20,
    },
  }) 